import React from 'react';
import { Stack, Typography } from '@mui/material';
import { AccessTime, Cancel, CheckCircle, InfoOutlined, Warning } from '@mui/icons-material';

const LEGEND_ITEMS = [
  { icon: <CheckCircle sx={{ color: 'success.main' }} />, label: 'Won' },
  { icon: <Cancel sx={{ color: 'warning.main' }} />, label: 'Lost' },
  { icon: <Warning sx={{ color: 'error.main' }} />, label: 'Overdue' },
  { icon: <AccessTime />, label: 'Expected close date' },
  { icon: <InfoOutlined sx={{ color: 'text.disabled' }} />, label: 'No date set' },
];

export const CloseDateLegend = () => (
  <Stack gap="0.25rem" padding="0.5rem">
    {LEGEND_ITEMS.map(({ icon, label }) => (
      <Stack key={label} direction="row" gap="0.5rem" alignItems="center">
        {icon}

        <Typography>-</Typography>

        <Typography>{label}</Typography>
      </Stack>
    ))}
  </Stack>
);
